import { css } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums/lib/index.js';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class EnergyLabelCardStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @param options.theme ...
	 * @param options.rescaled ...
	 * @param options.energyType ...
	 * @returns Styles.
	 */
	public static getStyle(options: {
		theme: ITheme;
		rescaled: boolean;
		energyType: string | null;
	}): string {
		return css`
			.container {
				display: flex;
				flex-direction: column;
			}
			.labels {
				flex-wrap: wrap;
				display: flex;
				justify-content: center;
				max-width: 100%;
			}
			img {
				outline: none;
				width: 100%;
			}
			.labels > * {
				margin: ${options.theme.spacing.space50 / 16}rem;
				overflow: hidden;
				width: 100%;
				display: flex;
				justify-content: center;
			}

			${this.getImageWidth({ rescaled: options.rescaled, energyType: options.energyType }) ?? ''}
		`;
	}

	private static getImageWidth(options: {
		rescaled: boolean;
		energyType: string | null;
	}): string | null {
		if (
			options.energyType === ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass &&
			options.rescaled
		) {
			return css`
				img {
					width: 74%;
				}
			`;
		}
		return null;
	}
}
